import { changeField, initialize } from 'modules/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as authAPI from 'lib/api/auth';
import { useCallback, useEffect, useState } from 'react';
import { validateLoginForm } from 'utils/validate';
import client, { serviceClient } from 'lib/api/client';

export const useLoginForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { username, password } = useSelector(({ auth }) => auth);
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(initialize());
  }, [dispatch]);

  const login = useCallback(async () => {
    try {
      const {
        data: {
          access_token,
          refresh_token,
          userLevel,
          type,
          id,
          name,
          changePassword,
          allowPersonalinfo,
        },
      } = await authAPI.login(username, password);

      dispatch(changeField({ key: 'accessToken', value: access_token }));
      dispatch(changeField({ key: 'refreshToken', value: refresh_token }));
      dispatch(changeField({ key: 'userLevel', value: userLevel }));
      dispatch(changeField({ key: 'userType', value: type }));
      dispatch(changeField({ key: 'userId', value: id }));
      dispatch(changeField({ key: 'username', value: name }));
      dispatch(changeField({ key: 'changePassword', value: changePassword }));
      dispatch(changeField({ key: 'email', value: username }));
      dispatch(
        changeField({ key: 'allowPersonalinfo', value: allowPersonalinfo }),
      );

      if (type === '1' && userLevel === '0') {
        localStorage.setItem('refreshToken', refresh_token);
        localStorage.setItem('username', username);
        localStorage.setItem('userLevel', userLevel);
        localStorage.setItem('userType', type);
        localStorage.setItem('userId', id);

        client.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${access_token}`;
        serviceClient.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${access_token}`;

        navigate(`/admin`);
        return;
      }

      if (type === '2' && userLevel === '0') {
        navigate(`/emailAuth`);
        return;
      }

      navigate(`/SMSAuth`);
    } catch (e) {
      setServerError(e?.response.data.msg);
    }
  }, [navigate, password, username, dispatch]);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      setIsSubmitting(false);
      login();
    }
  }, [errors, isSubmitting, login]);

  const onSubmit = e => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrors(validateLoginForm(username, password));
  };

  const onChange = e => {
    const { name, value } = e.target;
    dispatch(changeField({ key: name, value }));
  };

  return {
    username,
    password,
    errors,
    serverError,
    onChange,
    onSubmit,
  };
};
